import { BaseField } from '@/models/BaseField';
import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, ContentChild, ElementRef, Input, OnChanges, OnDestroy, OnInit, Optional, Self, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControlDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-radio',
  standalone: true,
  imports: [MatRadioModule, TranslateModule, ReactiveFormsModule,FormsModule,
    MatFormFieldModule,],
  templateUrl: './radio.component.html',
  styleUrl: './radio.component.scss'
})
export class RadioComponent {

  @Input() label: string | null = 'label manquant'; // translate key
  @Input() value: any = null;
  @Input() hasContent = false;
  @Input() hasBottom = false;
  @Input() isDisabled = false;
}
